/* Single – prijs/totaal updaten (eigen componenten) */
const unitStore = new WeakMap();

function formatMoney(n) {
  const p = window.wc_price_params || {};
  const dec  = p.decimal_sep || ',';
  const thou = p.thousand_sep || '.';
  const prec = Number.isFinite(Number(p.precision)) ? Number(p.precision) : 2;
  const sym  = p.currency_symbol || '€';
  const fmt  = p.price_format || '%s%v';
  const fixed = Number(n).toFixed(prec);
  const parts = fixed.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
  const val = parts.join(dec);
  return fmt.replace('%s', sym).replace('%v', val);
}

/* --- helpers: main form & totaalcontainer --- */
function getMainForm() {
  return (
    // geef grouped matrix (indien aanwezig) voorrang
    document.querySelector('.single-product form.wk-grouped-matrix[data-wc-main="1"]') ||
    document.querySelector('.single-product form.variations_form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.variations_form.cart') ||
    document.querySelector('.single-product form.cart')
  );
}

function getMainTotalContainer(form) {
  return (
    form?.closest('.single-product')?.querySelector('.wc-price-total[data-scope="main"]') ||
    document.querySelector('.wc-price-total[data-scope="main"]') ||
    form?.closest('.single-product')?.querySelector('.wc-price-total') ||
    document.querySelector('.single-product .wc-price-total')
  );
}

/* --- unit price state --- */
export function setUnitPrice(form, priceOrNull) {
  unitStore.set(form, (priceOrNull != null && isFinite(priceOrNull)) ? Number(priceOrNull) : null);
}
export function getUnitPrice(form) {
  const fromState = unitStore.get(form);
  if (fromState != null) return fromState;

  // fallback voor simple: data-unit-simple op de total container
  const cont = getMainTotalContainer(form);
  if (cont) {
    const v = cont.getAttribute('data-unit-simple');
    if (v !== '') return Number(v);
  }
  return null;
}

/* --- extras (checklist) --- */
function extrasTotal(form) {
  const scope = form?.closest('.single-product') || document;
  const nodes = Array.from(scope.querySelectorAll('.wk-xs-checklist input[name="wk_xs_ids[]"]:checked'))
    .filter((cb) => !cb.closest('[data-wk-xs-card]'));
  let sum = 0;
  nodes.forEach((cb) => {
    const p = Number(cb.getAttribute('data-price') || '');
    if (Number.isFinite(p)) sum += p;
  });
  return sum;
}

/* --- grouped helpers --- */
function groupedItemsTotal(form) {
  let sum = 0;
  const qtyInputs = form.querySelectorAll('.wk-gm-qty[name^="quantity["]');
  qtyInputs.forEach((inp) => {
    const q = Number(inp.value || 0);
    if (!Number.isFinite(q) || q <= 0 || inp.disabled) return;
    const unit = Number(inp.getAttribute('data-unit-price') || '');
    if (!Number.isFinite(unit)) return;
    sum += unit * q;
  });
  return sum;
}
function siblingsGroupedTotal(mainForm) {
  const scope = mainForm?.closest('.single-product') || document;
  const forms = Array.from(scope.querySelectorAll('form.wk-grouped-matrix'));
  let sum = 0;
  forms.forEach((f) => { if (f !== mainForm) sum += groupedItemsTotal(f); });
  return sum;
}

/* --- variatie prijs uit Woo object of HTML --- */
function getPriceFromVariation(variation, form) {
  // 1) meest betrouwbaar: display_price (Woo JSON; numeriek)
  if (variation && variation.display_price != null && isFinite(Number(variation.display_price))) {
    return Number(variation.display_price);
  }
  // 2) fallback: regular/sale
  const cand = [
    variation?.display_regular_price,
    variation?.display_sale_price,
    variation?.price, // soms aanwezig
  ].find((v) => v != null && isFinite(Number(v)));
  if (cand != null) return Number(cand);

  // 3) ultimate fallback: parse uit price_html (ondersteunt . en ,)
  const html = variation?.price_html || form?.querySelector('.single_variation_wrap .price')?.textContent || '';
  if (html) {
    // haal eerste getal met decimaal-separator . of ,
    const m = html.replace(/\s/g,'').match(/([0-9]{1,3}([.,][0-9]{3})*([.,][0-9]{2})?)/);
    if (m && m[1]) {
      const raw = m[1].replace(/\./g, '').replace(',', '.');
      const num = Number(raw);
      if (isFinite(num)) return num;
    }
  }
  return null;
}

/* --- hoofd: totaal updaten --- */
export function updateTotal(form) {
  if (!form || !form.matches('[data-wc-main="1"]')) return;

  const container = getMainTotalContainer(form);
  if (!container) return;

  const out = container.querySelector('[data-pt-amount]');
  if (!out) return;

  const extras = extrasTotal(form);

  // 1) main = grouped
  if (form.classList.contains('wk-grouped-matrix')) {
    const totalG = groupedItemsTotal(form);
    const total  = totalG + extras;
    out.innerHTML = total > 0 ? formatMoney(total) : '—';
    return;
  }

  // 2) main = simple/variable
  const qty  = Number(form?.querySelector('input.qty')?.value || 1);
  const unit = getUnitPrice(form); // wordt live gezet bij variaties

  let base = 0;
  if (unit != null && isFinite(unit)) {
    base = unit * Math.max(1, qty);
  }

  const groupedSiblings = siblingsGroupedTotal(form);
  const total = base + groupedSiblings + extras;

  out.innerHTML = total > 0 ? formatMoney(total) : '—';
}

/* --- Woo prijsblok verbergen (optioneel) --- */
function hideWooVarPrice(ctx) {
  const $ = window.jQuery;
  if (!$) return;
  $(ctx || document).find('.single_variation_wrap .woocommerce-variation-price').hide();
}

/* --- mount: events --- */
export function mount() {
  const $ = window.jQuery;
  const formForInit = getMainForm();

  if ($) {
    // Variatie gevonden → unit price vastzetten + totaal updaten
    $(document).on('found_variation woocommerce_variation_has_changed', 'form.variations_form', function (_e, variation) {
      if (!this.matches('[data-wc-main="1"]')) return;

      let price = getPriceFromVariation(variation, this);

      // Als er geen object is meegegeven, lookup via variation_id in data-product_variations
      if ((price == null || !isFinite(price))) {
        const id = parseInt($(this).find('input.variation_id').val(), 10);
        const all = $(this).data('product_variations');
        if (Array.isArray(all) && id) {
          const v = all.find((vv) => parseInt(vv.variation_id, 10) === id);
          price = getPriceFromVariation(v, this);
        }
      }

      setUnitPrice(this, price);
      updateTotal(this);
      hideWooVarPrice(this);
    });

    // Variatie gereset/verborgen
    $(document).on('reset_data hide_variation', 'form.variations_form', function () {
      if (!this.matches('[data-wc-main="1"]')) return;
      setUnitPrice(this, null);
      updateTotal(this);
      hideWooVarPrice(this);
    });
  }

  // Qty → totaal (simple/variable main form)
  document.addEventListener('input', (e) => {
    if (!e.target.matches('.single-product form.cart[data-wc-main="1"] input.qty')) return;
    updateTotal(e.target.closest('form'));
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('.single-product form.cart[data-wc-main="1"] input.qty')) return;
    updateTotal(e.target.closest('form'));
  });

  // Grouped matrix (ook NIET-main) → totaal hoofdformulier
  document.addEventListener('input', (e) => {
    if (!e.target.matches('.single-product form.wk-grouped-matrix .wk-gm-qty')) return;
    const main = getMainForm();
    if (main) updateTotal(main);
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('.single-product form.wk-grouped-matrix .wk-gm-check')) return;
    const main = getMainForm();
    if (main) updateTotal(main);
  });

  // Init: reken meteen door
  if (formForInit) {
    // Forceer Woo om de huidige selectie te evalueren (zeker bij custom UI)
    if ($ && formForInit.classList.contains('variations_form')) {
      $(formForInit).trigger('check_variations');
    }
    updateTotal(formForInit);
  }

  // CSS fallback blijft aanbevolen:
  // .single_variation_wrap .woocommerce-variation-price { display:none !important; }
}
